import { withSvgIcon } from './withSvgIcon';

export const UserIcon = withSvgIcon(
  <>
    <path
      d="M5 19.5V16C5 14.8954 5.89543 14 7 14H17C18.1046 14 19 14.8954 19 16V19.5"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle cx="12" cy="7" r="3" stroke="currentColor" strokeWidth="2" />
  </>,
  { viewBox: '0 0 24 24' },
);
